<template>
  <v-app id="app">
    <template v-if="!$route.meta.public">
      <AppToolbar/>
      <DialogVerifikasiHP/>
      <DialogNewMessage/>
      <DialogTopupSaldo/>
      <DialogCashOut/>
      <DialogTrfDanaAntasKas/>
      <DialogDetailUser/>
      <v-main class="ma-0">
        <UserToolbar v-if="accountlengkap && !syaratketentuan"/>
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-main>
    </template>
    <template v-else>
      <transition name="fade" mode="out-in">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar :timeout="5000" bottom right :color="alert.color" v-model="alert.show">
      {{ alert.message }}
      <template v-slot:action="{ attrs }">
        <v-btn icon
          color="white"
          text
          v-bind="attrs"
          @click="alert.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>

import AppToolbar from '@/components/ToolBar'
import AppEvents from './event'
import { mapActions, mapState } from 'vuex'
import UserToolbar from '@/components/UserToolbar'
import DialogTopupSaldo from '@/components/DialogTopupSaldo'
import DialogCashOut from '@/components/DialogCashOut'
import DialogTrfDanaAntasKas from '@/components/DialogTrfDanaAntasKas'
import DialogDetailUser from '@/components/DialogDetailUser'
import DialogNewMessage from '@/components/chat/DialogNewMessage'
import DialogVerifikasiHP from '@/components/DialogVerifikasiHP'
export default {
  name: 'App',

  components: {
    DialogVerifikasiHP,
    DialogNewMessage,
    DialogDetailUser,
    DialogTrfDanaAntasKas,
    DialogCashOut,
    DialogTopupSaldo,
    UserToolbar,
    AppToolbar
  },

  data: () => ({
    snackbar: {
      show: true,
      text: '',
      color: ''
    },
    token: localStorage.getItem('token'),
    user: localStorage.getItem('user')
  }),
  created () {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback)
    })
    window.getApp = this
  },
  mounted () {
    console.log('Mounted app')
    console.log(this.$route.params)
    console.log(this.$route)
    if (!this.$route.meta.public) {
      if (this.token) {
        this.getme()
        this.getCategory()
        this.getMemberBanks()
        if (this.$route.name !== 'home') {
          if (this.$route.name === 'supplierpage') {
            // this.$router.push(this.$route.params.id)
          } else {
            // this.$router.push(this.$route.name)
          }
        }
        const adata = {
          token: this.token,
          userid: JSON.parse(this.user).id
        }
        this.$socket.emit('logon', adata)
      } else {
        this.$router.push('/login')
      }
    } else {
      if (this.$route.params) {

      } else {
        if (!this.$route.params.token) {
          this.$router.push('/login')
        }
      }
    }
    this.getSliders()
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
      account: state => state.account
    }),
    ...mapState('authentication', ['accountlengkap', 'syaratketentuan'])
  },
  methods: {
    ...mapActions('authentication', ['getme']),
    ...mapActions('ProductStore', ['getBrands', 'getCategory']),
    ...mapActions('PublicStore', ['getSliders']),
    ...mapActions('SaldoStore', ['getMemberBanks'])
  }
}
</script>
